import { Button } from '@/components/ui/button'
import { useCommon } from '@/core/useCommon'
import { ROUTES } from '@/env/routes'
import { defineModal } from '@/ui/useModal'

// 密码更新提示 弹窗
const LastLoginModal = defineModal(
  ({ Dialog, onModalClose }) => {
    const { t, push } = useCommon()

    return (
      <Dialog className="max-h-full overflow-y-auto">
        <div className="rounded-12 w-320 bg-white p-12 sm:w-582 sm:px-30 sm:pt-20">
          {/* 標題 */}
          <div className="sm:text-20 text-16 text-[#0D2245]">{t('old:passwordUpdateTip')}</div>

          {/* 內容 */}
          <div className="text-12 sm:text-16 mt-16 text-[#6D7693] sm:mt-20">{t('old:fundpwdUpdateQA')}</div>

          {/* 按鈕區塊 */}
          <div className="mt-16 flex justify-end gap-8 sm:mt-20">
            <div>
              <Button variant="outline" className="rounded-4 text-12 sm:rounded-8 sm:text-16 h-32 px-12 sm:h-36" onClick={onModalClose}>
                {t('old:updateLater')}
              </Button>
            </div>

            <div>
              <Button
                className="rounded-4 text-12 sm:rounded-8 sm:text-16 h-32 px-12 sm:h-36"
                onClick={() => {
                  push(ROUTES.UPDATE_PASSWORD())
                  onModalClose()
                }}>
                {t('old:updateImmediately')}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
    )
  },
  {
    bgClose: false,
  },
)

export default LastLoginModal
